"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoundKeybind = SoundKeybind;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var availableKeybindKeys = [
    "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o",
    "p", "q", "r", "t", "u", "v", "w", "x", "y", "z", "1", "2", "3", "4",
    "5", "6", "7", "8", "9", "0"
];
function SoundKeybind(_a) {
    var _this = this;
    var sound = _a.sound, soundList = _a.soundList, enabled = _a.enabled, onSelect = _a.onSelect;
    var _b = (0, react_1.useState)(false), active = _b[0], setActive = _b[1];
    var keybind = (0, react_1.useMemo)(function () { return soundList.keybinds.get().find(function (keybind) { return keybind.soundId === sound.id; }); }, [sound, enabled, soundList, soundList.keybinds]);
    (0, react_1.useEffect)(function () {
        var onKeyDown = function (e) {
            if (!enabled || !active)
                return;
            if (e.key == 'Delete') {
                soundList.setKeybind(sound, null);
                return;
            }
            if (!keybind || availableKeybindKeys.includes(e.key) && e.key != keybind.key) {
                soundList.setKeybind(sound, e.key);
            }
        };
        window.addEventListener('keydown', onKeyDown);
        return function () {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [sound, soundList, active, keybind, enabled]);
    var onEnter = (0, react_1.useCallback)(function () {
        if (enabled) {
            setActive(true);
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(sound);
        }
    }, [sound, enabled]);
    var onExit = (0, react_1.useCallback)(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setActive(false);
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(null);
            return [2 /*return*/];
        });
    }); }, []);
    return (0, jsx_runtime_1.jsx)("span", { className: "sound-keybind".concat(active ? ' active' : ''), onMouseEnter: onEnter, onMouseLeave: onExit, onClick: function (e) { return e.preventDefault(); }, children: keybind && keybind.key ? keybind.key : '-' });
}
